import React from "react"
import {getDayName} from "./utils";
import moment from "moment"


export default class NextWeekEvents extends React.Component {
  addToClipboard = (text) => {
    this.props.handleClipboard(text)
  }
  handleNextWeekEvents = (nextWeek) =>  {
    const output = []
    if (nextWeek.length) {
      this.addToClipboard("Events for next week:\n\n")
    }
    nextWeek.sort((a, b) => {
      if(moment(a.fields["Start time"]).isAfter(b.fields["Start time"]))
        return 1
      if(moment(a.fields["Start time"]).isBefore(b.fields["Start time"]))
        return -1
      return 0
    })
    nextWeek.forEach(record => {
      const dayNumber = new Date(record.fields["Start time"]).getDay()
      const out = `- ${ record.fields.Name } (${ getDayName(dayNumber) }: ${ record.fields["City"] })`
      output.push(out)
      this.addToClipboard(out + "\n")
    })
    return output
  }
  render() {
    return (
      <div>
        <h3>Events for next week: {this.props.events.length}</h3>
        {
          this.handleNextWeekEvents(this.props.events).map((el, i) => (
            <p key={i}>{el}</p>
          ))
        }
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/components/Main/NextWeek.js